import { CLEAR_MESSAGE, SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE } from "./types";
export const setSuccessMessage = (message) => ({
  type: SET_SUCCESS_MESSAGE,
  payload: message,
});

export const setFailedMessage = (message) => ({
  type: SET_FAILED_MESSAGE,
  payload: message,
});

export const clearMessage = () => (dispatch) => dispatch({ type: CLEAR_MESSAGE });